import { render, staticRenderFns } from "./item_finnace_type.vue?vue&type=template&id=50f5b0b6&scoped=true&"
import script from "./item_finnace_type.vue?vue&type=script&lang=js&"
export * from "./item_finnace_type.vue?vue&type=script&lang=js&"
import style0 from "./item_finnace_type.vue?vue&type=style&index=0&id=50f5b0b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f5b0b6",
  null
  
)

export default component.exports